// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import { type RasterMeta, RasterMetaFromJSON, RasterMetaToJSON } from "../models/RasterMeta";
import {
  type RasterStyleFilename,
  RasterStyleFilenameFromJSON,
  RasterStyleFilenameToJSON,
} from "../models/RasterStyleFilename";
import {
  type RasterUserSuppliedMeta,
  RasterUserSuppliedMetaFromJSON,
  RasterUserSuppliedMetaToJSON,
} from "../models/RasterUserSuppliedMeta";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface GetRasterStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  fileName: RasterStyleFilename;
}

export interface PublicationGetRasterStyleRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  fileName: RasterStyleFilename;
}

export interface UpdateRasterMetaRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  rasterUserSuppliedMeta: RasterUserSuppliedMeta;
}

export interface UploadRasterStylesRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  files: Array<Blob>;
}

/**
 *
 */
export class RastersApi extends runtime.BaseAPI {
  /**
   * Creates request options for getRasterStyle without sending the request
   * @deprecated
   */
  async getRasterStyleRequestOpts(
    requestParameters: GetRasterStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling getRasterStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling getRasterStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling getRasterStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/raster-style/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the raster\'s styles
   * @deprecated
   */
  async getRasterStyleRaw(
    requestParameters: GetRasterStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.getRasterStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the raster\'s styles
   * @deprecated
   */
  async getRasterStyle(
    requestParameters: GetRasterStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.getRasterStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationGetRasterStyle without sending the request
   * @deprecated
   */
  async publicationGetRasterStyleRequestOpts(
    requestParameters: PublicationGetRasterStyleRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationGetRasterStyle().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationGetRasterStyle().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling publicationGetRasterStyle().'
      );
    }

    if (requestParameters["fileName"] == null) {
      throw new runtime.RequiredError(
        "fileName",
        'Required parameter "fileName" was null or undefined when calling publicationGetRasterStyle().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/file-descriptors/{file_descriptor_id}/raster-style/{file_name}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{file_name}",
      encodeURIComponent(String(requestParameters["fileName"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the raster\'s styles
   * @deprecated
   */
  async publicationGetRasterStyleRaw(
    requestParameters: PublicationGetRasterStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.publicationGetRasterStyleRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * DEPRECATED - use the generic /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles/{style_id}/{file_name} endpoint instead.
   * retrieve the raster\'s styles
   * @deprecated
   */
  async publicationGetRasterStyle(
    requestParameters: PublicationGetRasterStyleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.publicationGetRasterStyleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for updateRasterMeta without sending the request
   * @deprecated
   */
  async updateRasterMetaRequestOpts(
    requestParameters: UpdateRasterMetaRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling updateRasterMeta().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling updateRasterMeta().'
      );
    }

    if (requestParameters["rasterUserSuppliedMeta"] == null) {
      throw new runtime.RequiredError(
        "rasterUserSuppliedMeta",
        'Required parameter "rasterUserSuppliedMeta" was null or undefined when calling updateRasterMeta().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/raster-meta`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: RasterUserSuppliedMetaToJSON(requestParameters["rasterUserSuppliedMeta"]),
    };
  }

  /**
   * DEPRECATED - use the generic /meta endpoint instead.
   * update the raster\'s style
   * @deprecated
   */
  async updateRasterMetaRaw(
    requestParameters: UpdateRasterMetaRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RasterMeta>> {
    const requestOptions = await this.updateRasterMetaRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterMetaFromJSON(jsonValue));
  }

  /**
   * DEPRECATED - use the generic /meta endpoint instead.
   * update the raster\'s style
   * @deprecated
   */
  async updateRasterMeta(
    requestParameters: UpdateRasterMetaRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RasterMeta> {
    const response = await this.updateRasterMetaRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for uploadRasterStyles without sending the request
   * @deprecated
   */
  async uploadRasterStylesRequestOpts(
    requestParameters: UploadRasterStylesRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling uploadRasterStyles().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling uploadRasterStyles().'
      );
    }

    if (requestParameters["files"] == null) {
      throw new runtime.RequiredError(
        "files",
        'Required parameter "files" was null or undefined when calling uploadRasterStyles().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["files"] != null) {
      requestParameters["files"].forEach((element) => {
        formParams.append("files", element as any);
      });
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/raster-style`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * DEPRECATED - use the POST /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles endpoint instead. Supported style filenames are: colormap.json, qml.zip
   * Upload raster style files
   * @deprecated
   */
  async uploadRasterStylesRaw(
    requestParameters: UploadRasterStylesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.uploadRasterStylesRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * DEPRECATED - use the POST /tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/styles endpoint instead. Supported style filenames are: colormap.json, qml.zip
   * Upload raster style files
   * @deprecated
   */
  async uploadRasterStyles(
    requestParameters: UploadRasterStylesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.uploadRasterStylesRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
